/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetBuyerOrdersRequest} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'
import {GetBuyerOrdersResponse} from '@cash-web/protos/squareup/cash/local/client/v1/cash_app_local_client_service.pb'


export const getBuyerOrders = (request: GetBuyerOrdersRequest, options?: CashRequestOptions) => post<GetBuyerOrdersRequest, GetBuyerOrdersResponse>("/cash-app/local/orders/history", request, {...options, rejectOnError: true })